import React, { useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useReactToPrint } from 'react-to-print';
import Step2NotificationLetter from '../PdfLetters/Step2NotificationLetter';
import { Button, Icon, Message } from 'semantic-ui-react';
import { setPage } from '../../redux/appSlice';
import axios from 'axios';
import { setLetter } from "../../redux/projectSlice";

const useTitle = (title) => {
    useEffect(() => {
        const prevTitle = document.title;
        document.title = title;
        return () => {
            document.title = prevTitle;
        }
    })
}


const Step2NotificationLetterService = () => {
    const projectState = useSelector(state => state.project);
    const appState = useSelector(state => state.app);
    const projectChecklists = useSelector(state => state.project.projectChecklists);
    const dispatch = useDispatch();
    const componentRef = useRef();
    const API_MDB = process.env.REACT_APP_BASE_API_URL_MDB;
    const options = {
        headers: { 'Content-Type': 'application/json' },
        withCredentials: true
    }
    const handlePrint = useReactToPrint({
        content: () => componentRef.current
    });

    const updateLetterDataAndPrint = async () => {
        const resLetter = await axios.patch(API_MDB + '/letters/' + projectState.letter._id, projectState.letter, options);
        if (resLetter.status === 204) {
            handlePrint();
        }
    }


    const displayError = (error, title, message) => {
        return (<Message negative><Message.Header>{title}</Message.Header>{message}</Message>);
    }

    const getDecision = () => {
        const project = projectState.project
        if (project.secondStepDecision !== null) {
            if (project.secondStepDecision.preFundingDecision !== null || project.secondStepDecision.finalFundingDecision !== null) {
                
                if (project.secondStepDecision?.preFundingDecision?.status === 'APPROVED_WITH_CONDITIONS' || project.secondStepDecision?.finalFundingDecision?.status === 'APPROVED') {
                    //return <Step2DetailApproval projectState={projectState} />
                    return 'APPROVAL'
                } else {
                    return 'REJECTION'
                }
            }
            if (project.secondStepDecision.eligibilityDecision !== null) {
                if (project.secondStepDecision.eligibilityDecision.status === 'ELIGIBLE') {
                    return 'Eligible'
                } else {
                    return 'INELIGIBLE'
                }
            } else {
                return displayError(null, 'There is no Step2 Decision at the moment', 'It\'s not possible to print a notification letter without any decision, please check in Jems application if the Step2 decision is available');
            }
        } else {
            return displayError(null, 'There is no Step2 Decision at the moment', 'It\'s not possible to print a notification letter without any decision, please check in Jems application if the Step2 decision is available');
        }
    }

    const getLetterData = async () => {
        //console.log('getLetterData')
        //console.warn(projectState.letter.projectNumber)

        if (!projectState.letter.projectNumber) {
            console.log('getLetterData')
            const resLetter = await axios.get(API_MDB + '/letters/' + projectState.project.customIdentifier, options);
            if (resLetter.status === 200) {
                let letter = resLetter.data
                if (letter.projectNumber !== undefined) {
                    dispatch(setLetter(letter));
                    if (!letter.step2Data) {
                        const jsOpinion = getJsOpinion();
                        let newLetter = Object.assign({}, letter);
                        let step2Data = {};
                        step2Data.projectRelevance = jsOpinion.details[0].explanation;
                        step2Data.partnershipCooperation = jsOpinion.details[1].explanation;
                        step2Data.projectIntervention = jsOpinion.details[2].explanation;
                        step2Data.workPlan = jsOpinion.details[3].explanation;
                        step2Data.communication = jsOpinion.details[4].explanation;
                        step2Data.budget = jsOpinion.details[5].explanation;
                        step2Data.additional = jsOpinion.details[6].explanation;
                        newLetter.step2Data = step2Data;
                        dispatch(setLetter(newLetter));
                    }
                } else {
                    let newLetter = {};
                    newLetter.projectNumber = projectState.project.customIdentifier;
                    newLetter.callNumber = projectState.project.callSettings.callId;
                    newLetter.step1Decision = projectState.project.eligibilityDecision;
                    newLetter.step2Decision = projectState.project.eligibilityDecision;
                    const jsOpinion = getJsOpinion();
                    if (jsOpinion !== undefined) {
                        let step2Data = {};
                        step2Data.projectRelevance = jsOpinion.details[0].explanation;
                        step2Data.partnershipCooperation = jsOpinion.details[1].explanation;
                        step2Data.projectIntervention = jsOpinion.details[2].explanation;
                        step2Data.workPlan = jsOpinion.details[3].explanation;
                        step2Data.communication = jsOpinion.details[4].explanation;
                        step2Data.budget = jsOpinion.details[5].explanation;
                        step2Data.additional = jsOpinion.details[6].explanation;
                        newLetter.step2Data = step2Data;
                        const resCommission = await axios.get(API_MDB + '/commissions/' + projectState.project.callSettings.callId, options);
                        if (resCommission.status === 200) {
                            newLetter.commission = resCommission.data;
                            if (projectState.letter.projectNumber === undefined) {
                                dispatch(setLetter(newLetter));
                                axios.post(API_MDB + '/letters', newLetter, options).then(res => {
                                    dispatch(setLetter(res.data));
                                }).catch(err => {
                                    console.log(err);
                                });
                            }
                        } else {
                            console.warn('Error fetching commission data');
                        }
                    } else {
                        console.warn('Error fetching jsOpinion data');
                    }
                }
            } else {
                console.warn('Error fetching letter data');
            }
        }
    }

    const getChecklistByName = (name) => {
        let checklist = undefined;
        const checklists = projectState.projectChecklists;
        try {
            for (let i = 0; i < checklists.length; i++) {
                if (checklists[i].name === name) {
                    checklist = checklists[i];
                    return checklist;
                }
            }
        } catch (error) {
            return undefined
        }
    }

    const getJsOpinion = () => {
        const jsOpinionChecklistName = projectState.step2JSOpinion;
        //console.log(jsOpinionChecklistName);
        const jsOpinionChecklist = getChecklistByName(jsOpinionChecklistName);
        //console.log(jsOpinionChecklist);
        if (jsOpinionChecklist === undefined) {
            return undefined;
        }
        let jsOpinionComponents = jsOpinionChecklist.detail.components;
        let sortedComponents = jsOpinionComponents.slice().sort((a, b) => a.position - b.position);
        let jsOpinion = {};
        jsOpinion.details = [];
        jsOpinion.summary = sortedComponents[1].instanceMetadata.explanation;
        jsOpinion.opinion = sortedComponents[2].instanceMetadata.answer;
        jsOpinion.opinionDetail = sortedComponents[2].instanceMetadata.justification;
        for (let i = 3; i < sortedComponents.length; i++) {
            if (sortedComponents[i].type === 'TEXT_INPUT') {
                let detail = {};
                detail.question = sortedComponents[i].programmeMetadata.question;
                detail.explanation = sortedComponents[i].instanceMetadata.explanation;
                jsOpinion.details.push(detail);
            }
        }
        return jsOpinion;
    }


    getLetterData();
    const letterTitle = projectState.project.callSettings?.endDateStep1 === null ? 
        'P' + projectState.project.programmePriority.code+'_'+projectState.project.customIdentifier+'_'+projectState.project.acronym+'_SSP_'+getDecision()
        : 'P' + projectState.project.programmePriority.code+'_'+projectState.project.customIdentifier+'_'+projectState.project.acronym+'_S2_'+getDecision()
    //useTitle('Notification Letter - ' + projectState.project.customIdentifier);
    useTitle(letterTitle);
    // dispatch(loadingEnd());
    return (
        <div>
            <div className='menu'>
                <Button.Group>
                    <Button icon onClick={() => dispatch(setPage('Projects'))} color='blue' labelPosition='left'>
                        <Icon name='arrow left' />
                        Back
                    </Button>
                    <Button.Or />
                    <Button icon onClick={updateLetterDataAndPrint} color='blue' labelPosition='right'>
                        <Icon name='save' />
                        Save / Print
                    </Button>
                </Button.Group>

            </div>
            {appState.jems32 ? <Message warning><Message.Header>You're connected to Jems32 server.</Message.Header>Collected data may not reflect the live server please use <a href="http://jemsreports.nweurope.eu/" target="_blank" rel="noopener noreferrer">Jems Live Server</a></Message> : undefined}
            {/* <div><ProjectDetail ref={componentRef} projectState={projectState} projectChecklists={projectChecklists} setError={() => setError} /></div> */}

            <Step2NotificationLetter ref={componentRef} projectState={projectState} projectChecklists={projectChecklists} />
        </div>
    );
}

export default Step2NotificationLetterService;